var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha-holder"},[_c('vue-recaptcha',{attrs:{"sitekey":_vm.siteKey},on:{"verify":function($event){return _vm.$emit('validate', _vm.onVerify)}}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32816379","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/admin/components/VRecaptcha.vue
// module id = DMXG
// module chunks = 1